import React, { useState, useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';

import PatientNavbar from '../components/PatientNavbar';
import PresentationNavbar from '../components/PresentationNavbar';
// import hairImagesCloseup from "../assets/images/hairImagesCloseup.png";
import dayjs from 'dayjs';
import Loading from './Loading';

export default function HairImages() {
  const { id } = useParams();

  const [message, setMessage] = useState('');
  const [ready, setReady] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [viewMode, setViewMode] = useState('front');
  const [currentId, setCurrentId] = useState(0);
  const [hairImagesDetails, setHairImagesDetails] = useState([]);
  const [patientReferrals, setPatientReferrals] = useState(null);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}/hair_analysis/all?patient_id=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          setFirstName(response.firstName);
          setLastName(response.lastName);
          setPatientReferrals(response.referral);
          var imageDetails = [];
          for (var index = 0; index < response.hair_analysis.length; index++) {
            var temp = {};
            temp['date'] = response.hair_analysis[index].created_at;
            temp['front'] = [];
            temp['crown'] = [];
            temp['vertex'] = [];
            temp['back'] = [];
            temp['left'] = [];
            temp['right'] = [];

            temp['front'].hairLineIndex =
              response.hair_analysis[index].groindex.hairLine;

            temp['front'].hairDensityScore =
              response.hair_analysis[index].groindex.hairDensity.front;
            temp['crown'].hairDensityScore =
              response.hair_analysis[index].groindex.hairDensity.crown;
            temp['vertex'].hairDensityScore =
              response.hair_analysis[index].groindex.hairDensity.vertex;
            temp['left'].hairDensityScore =
              response.hair_analysis[index].groindex.hairDensity.left;
            temp['back'].hairDensityScore =
              response.hair_analysis[index].groindex.hairDensity.back;
            temp['right'].hairDensityScore =
              response.hair_analysis[index].groindex.hairDensity.right;

            // temp['front'].ht = response.hair_analysis[index].gromeasure.front.hairDiameter;
            temp['crown'].ht =
              response.hair_analysis[index].gromeasure.crown.hairDiameter;
            temp['vertex'].ht =
              response.hair_analysis[index].gromeasure.vertex.hairDiameter;
            temp['left'].ht =
              response.hair_analysis[index].gromeasure.left.hairDiameter;
            temp['back'].ht =
              response.hair_analysis[index].gromeasure.back.hairDiameter;
            temp['right'].ht =
              response.hair_analysis[index].gromeasure.right.hairDiameter;

            temp['front'].imgSrc = getImagePath(
              response.hair_analysis[index].images.closeup,
              'front'
            );
            temp['crown'].imgSrc = getImagePath(
              response.hair_analysis[index].images.closeup,
              'crown'
            );
            temp['vertex'].imgSrc = getImagePath(
              response.hair_analysis[index].images.closeup,
              'vertex'
            );
            temp['left'].imgSrc = getImagePath(
              response.hair_analysis[index].images.closeup,
              'left'
            );
            temp['back'].imgSrc = getImagePath(
              response.hair_analysis[index].images.closeup,
              'occipital'
            );
            temp['right'].imgSrc = getImagePath(
              response.hair_analysis[index].images.closeup,
              'right'
            );

            imageDetails.push(temp);
          }
          setHairImagesDetails(imageDetails);
          setCurrentId(0);
        } else {
          setMessage(response.message);
        }
        setReady(true);
      })
      .catch(error => {
        console.error(error);
        setMessage('Some Error Occured. Please Try Again Later');
      });
  }, [id]);

  const getImagePath = (array, subType) => {
    for (var index = 0; index < array.length; index++) {
      if (array[index].subType === subType) {
        return array[index].image_path;
      }
    }
    return null;
  };

  return (
    <>
      <main
        className={`mx-auto container flex flex-col p-4 ${
          ready ? '' : 'hidden'
        }`}
      >
        <PatientNavbar id={id} tab={6} />
        {message && <p className="mt-8 text-center text-red-600">{message}</p>}
        <section className="mt-6">
          <div>
            {patientReferrals ? (
              <h1 className="px-12 flex  justify-center mt-4 text-lg text-center text-text-4">
                {`${firstName} ${lastName} referred by ${patientReferrals.referred_by}`}
              </h1>
            ) : (
              <h1 className="px-12 flex  justify-center mt-4 text-lg text-center text-text-4">
                {`${firstName} ${lastName}`}
              </h1>
            )}
            <div className="flex flex-col items-center px-12 md:justify-between md:flex-row">
              <button className="flex items-center my-2 mr-12 focus:outline-none">
                <NavLink
                  to={`/patient/presentation/hair-images/global-images/${id}`}
                >
                  <h2 className="text-xl font-bold text-text-1">
                    Global Images
                  </h2>
                </NavLink>
              </button>
              <div className="flex items-center my-2 ml-2 text-text-1">
                <button
                  className="text-2xl font-bold focus:outline-none"
                  onClick={function () {
                    if (currentId > 0) {
                      setCurrentId(currentId - 1);
                    }
                  }}
                >
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 256 512"
                  >
                    <path
                      fill="#bfc5ca"
                      d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
                    />
                  </svg>
                </button>
                <p className="mx-4 text-center">
                  {hairImagesDetails[currentId]
                    ? dayjs
                        .unix(hairImagesDetails[currentId].date)
                        .format('M-D-YYYY')
                    : ''}
                </p>
                <button
                  className="text-2xl font-bold focus:outline-none"
                  onClick={function () {
                    if (currentId + 1 < hairImagesDetails.length) {
                      setCurrentId(currentId + 1);
                    }
                  }}
                >
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 256 512"
                  >
                    <path
                      fill=" #bfc5ca"
                      d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                    />
                  </svg>
                </button>
              </div>
              <button className="flex items-center my-2 focus:outline-none">
                <NavLink
                  to={`/patient/presentation/hair-images/close-up-hair-images/${id}`}
                >
                  <h2 className="text-xl font-bold text-text-3">
                    Close-up Hair Images
                  </h2>
                </NavLink>
              </button>
            </div>
          </div>
          <div
            className="px-4 py-8 mt-4 bg-background-5 overflow-hidden"
            style={{ height: 'var(--height-2)' }}
          >
            <div className="flex items-center justify-center mx-auto">
              <button
                className={`${
                  viewMode === 'front' && 'text-text-3 '
                } text-base font-normal focus:outline-none mx-2 font-font-2`}
                onClick={() => setViewMode('front')}
              >
                Front
              </button>
              <button
                className={`${
                  viewMode === 'crown' && 'text-text-3 '
                } text-base font-normal focus:outline-none mx-2 font-font-2`}
                onClick={() => setViewMode('crown')}
              >
                Crown
              </button>
              <button
                className={`${
                  viewMode === 'vertex' && 'text-text-3 '
                } text-base font-normal focus:outline-none mx-2 font-font-2`}
                onClick={() => setViewMode('vertex')}
              >
                Vertex
              </button>
              <button
                className={`${
                  viewMode === 'back' && 'text-text-3 '
                } text-base font-normal focus:outline-none mx-2 font-font-2`}
                onClick={() => setViewMode('back')}
              >
                Back
              </button>
              <button
                className={`${
                  viewMode === 'left' && 'text-text-3 '
                } text-base font-normal focus:outline-none mx-2 font-font-2`}
                onClick={() => setViewMode('left')}
              >
                Left
              </button>
              <button
                className={`${
                  viewMode === 'right' && 'text-text-3 '
                } text-base font-normal focus:outline-none mx-2 font-font-2`}
                onClick={() => setViewMode('right')}
              >
                Right
              </button>
            </div>
            <div className="flex items-center justify-center">
              <button
                className="text-2xl focus:outline-none"
                onClick={function () {
                  if (currentId > 0) {
                    setCurrentId(currentId - 1);
                  }
                }}
              >
                <svg
                  // className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 256 512"
                  width="50"
                  height="50"
                >
                  <path
                    fill="#6e7884"
                    d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
                  />
                </svg>
              </button>
              <div className="grid justify-center flex-grow grid-cols-3 mt-2">
                {(viewMode === 'front' ||
                  viewMode === 'crown' ||
                  viewMode === 'vertex' ||
                  viewMode === 'left' ||
                  viewMode === 'right' ||
                  viewMode === 'back') && (
                  <>
                    {hairImagesDetails.map(
                      (hID, idx) =>
                        (idx === currentId - 1 ||
                          idx === currentId ||
                          idx === currentId + 1) && (
                          <div
                            key={idx}
                            className={
                              currentId === 0 && idx === 0 ? 'col-start-2' : ''
                            }
                          >
                            <div
                              className="flex flex-col items-center justify-start p-4"
                              style={{ width: '400px' }}
                            >
                              <div className="mt-4">
                                {hID[viewMode].imgSrc ? (
                                  <img
                                    src={hID[viewMode].imgSrc}
                                    alt="Front Img"
                                    style={{ maxWidth: '100%' }}
                                    className="h-96"
                                  />
                                ) : (
                                  <div
                                    className="h-96"
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    No Image found
                                  </div>
                                )}
                              </div>
                            </div>
                            <h2
                              className="flex items-end justify-center py-2 text-xl font-bold leading-5 text-center border-t font-font-2 border-text-1"
                              style={{ height: 70 }}
                            >
                              {hID.date
                                ? `${dayjs.unix(hID.date).format('M-D-YYYY')}:`
                                : ''}
                              <div className="ml-2">HD </div>
                              <div
                                className="text-xs ml-2 text-black text-center"
                                style={{ position: 'relative' }}
                              >
                                <div
                                  className="flex bg-gray-100"
                                  style={{
                                    backgroundColor: '#F7A79D',
                                    height: `${
                                      2 * (hID[viewMode].hairDensityScore / 80)
                                    }rem`,
                                    position: 'absolute',
                                    width: '100%',
                                    bottom: 0,
                                    zIndex: '1',
                                  }}
                                ></div>
                                <p
                                  className="px-2 mt-auto text-center"
                                  style={{
                                    zIndex: '1000',
                                    position: 'relative',
                                  }}
                                >
                                  {hID[viewMode].hairDensityScore}
                                </p>
                              </div>
                              <div className="ml-2">HT </div>
                              <div
                                className="text-xs ml-2 text-black text-center"
                                style={{ position: 'relative' }}
                              >
                                {hID[viewMode].ht && (
                                  <div
                                    className="flex bg-gray-100"
                                    style={{
                                      backgroundColor: '#13c3b2',
                                      height: `${
                                        3 * (hID[viewMode].ht / 0.03)
                                      }rem`,
                                      position: 'absolute',
                                      width: '100%',
                                      bottom: 0,
                                      zIndex: '1',
                                    }}
                                  ></div>
                                )}
                                <p
                                  className="px-2 mt-auto text-center"
                                  style={{
                                    zIndex: '1000',
                                    position: 'relative',
                                  }}
                                >
                                  {hID[viewMode].ht}
                                </p>
                              </div>
                            </h2>
                          </div>
                        )
                    )}
                  </>
                )}
                {/* {(viewMode === "front" ||
                viewMode === "crown" ||
                viewMode === "vertex" ||
                viewMode === "left" ||
                viewMode === "right" ||
                viewMode === "back") && (
                <>
                  {hairImagesDetails.map((hID, idx) => (
                    <h2
                      key={idx}
                      className="flex items-end justify-center pt-4 mt-4 text-xl font-bold leading-5 text-center border-t font-font-2 border-text-1">
                      {dayjs(hID.date).format("MM-DD-YY")}: HD{" "}
                      <div
                        className="flex mx-2 text-xs text-black bg-gray-100"
                        style={{
                          backgroundColor: "#F7A79D",
                          height: `${
                            2 * (hID[viewMode].hairDensityScore / 80)
                          }rem`,
                        }}>
                        <p className="px-2 mt-auto">
                          {hID[viewMode].hairDensityScore}
                        </p>
                      </div>
                      HT
                      <div
                        className="flex ml-2 text-xs text-black bg-gray-100"
                        style={{
                          backgroundColor: "#13c3b2",
                          height: `${3 * (hID[viewMode].ht / 0.03)}rem`,
                        }}>
                        <p className="px-1 mt-auto">{hID[viewMode].ht}</p>
                      </div>
                    </h2>
                  ))}
                </>
              )} */}
              </div>
              <button
                className="text-2xl focus:outline-none"
                onClick={function () {
                  if (currentId + 1 < hairImagesDetails.length) {
                    setCurrentId(currentId + 1);
                  }
                }}
              >
                <svg
                  // className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 256 512"
                  width="50"
                  height="50"
                >
                  <path
                    fill="#6e7884"
                    d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </section>

        <PresentationNavbar id={id} tab={2} />
      </main>
      <Loading message={'Loading Hair Gro Tracker'} ready={ready} />
    </>
  );
}
